import type { AreaMapObservationArea } from "@/features/deployment-dashboard/shared/api/area-map-response";
import { worldToFloorplanPixel } from "@/features/deployment-dashboard/widgets/panels/facility-schematic/services/world-to-pixel-transform";
import type { WorldToPixelTransformAsset } from "@/features/deployment-dashboard/widgets/panels/facility-schematic/services/world-to-pixel-transform";
import type { ObservationAreaBoundary } from "@/features/deployment-dashboard/types";

/**
 * Maps a deployment area's observation area boundaries - already returned in
 * the area's own world coordinate frame (easting/northing metres) by
 * `GET /v1/areas/{areaId}/map` - into the facility schematic's pixel
 * coordinate space via `worldToFloorplanPixel`.
 *
 * Returns no boundaries while `transform` hasn't loaded yet (see
 * `useFacilitySchematicAssets`).
 */
export function deriveObservationAreaBoundaries(
  transform: Pick<WorldToPixelTransformAsset, "matrix"> | undefined,
  observationAreas: AreaMapObservationArea[]
): ObservationAreaBoundary[] {
  if (!transform) return [];

  return observationAreas.map((observationArea) => ({
    id: observationArea.observationAreaId,
    name: observationArea.observationAreaName,
    points: observationArea.polygon.vertices.map((vertex) =>
      worldToFloorplanPixel(transform, vertex.eastingM, vertex.northingM)
    ),
  }));
}
